<template>
  <div class="text-justify">
    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5>
          {{
            ["OCPR", "CSGAS", "OCSG", "CSA", "CSIA"].includes(activity)
              ? "3. ORGANIZACIÓN MATRIZ Y LOCALIZACIONES"
              : ["OCPE"].includes(activity)
              ? "3 UBICACIONES DEL ORGANISMO DE CERTIFICACIÓN"
              : ["OINSP"].includes(activity)
              ? "3 ORGANIZACIÓN MATRIZ, LOCACIONES CRITICAS Y UNIDADES TÉCNICAS"
              : ["OENY", "OEYC"].includes(activity)
              ? "4 ORGANIZACIÓN MATRIZ Y UNIDADES TÉCNICAS"
              : ["OCLN", "OICC"].includes(activity)
              ? "3 ORGANIZACIÓN MATRIZ Y UNIDADES TÉCNICAS"
              : ["OEAP"].includes(activity)
              ? "3 ORGANIZACIONES CON OTRAS ACREDITACIONES"
              : ""
          }}
        </h5>
      </legend>
    </div>

    <OrganizationParent
      v-if="
        [
          'OEYC',
          'OENY',
          'OCLN',
          'OICC',
          'OINSP',
          'OCSG',
          'CSIA',
          'CSA',
          'CSGAS',
          'OCPR',
          'OCPE',
        ].includes(activity)
      "
      :activity="activity"
      :disabled="disabled"
    />

    <!-- Certificación - Productos -->
    <div v-if="['OCPR'].includes(activity)">
      <branchs-critical-table
        title="3.2 LOCALIZACIONES CRÍTICAS DEL ORGANISMO SOLICITANTE"
        tableId="branchs-table"
        modalTitle="Añadir Locación critica del organismo solicitante"
        editModalTitle="Editar Locación critica del organismo solicitante"
        :activity="activity"
        :disabled="disabled"
      />

      <branchs-table
        title="3.3 LOCALIZACIONES NO CRÍTICAS DEL ORGANISMO SOLICITANTE"
        tableId="branchs-table"
        modalTitle="Añadir localización no crítica"
        editModalTitle="Editar localización no crítica"
        :activity="activity"
        :disabled="disabled"
        establishmentType="B"
      />

      <acc-virtual-sites-table
        title="3.4 SITIOS VIRTUALES DEL ORGANISMO SOLICITANTE (cuando aplique)"
        tableId="acc-virtual-sites-table"
        modalTitle="Añadir Sitio Virtual del Organismo"
        editModalTitle="Editar Sitio Virtual del Organismo"
        :activity="activity"
        :disabled="disabled"
      />

      <certification-activities-table
        title="3.5 INFORMACIÓN GENERAL DE LAS ACTIVIDADES DE CERTIFICACIÓN (ver requisito 3.1 de IAF MD12:2016)"
        tableId="certification-activities-table"
        modalTitle="Añadir actividades de certificación"
        editModalTitle="Editar actividades de certificación"
        :activity="activity"
        :disabled="disabled"
      />

      <acc-bodies-table
        title="3.6 ACREDITACIONES OBTENIDAS CON OTROS ORGANISMOS DE ACREDITACIÓN"
        tableId="acc-bodies-table"
        modalTitle="Añadir Organismo de Acreditación"
        editModalTitle="Editar Organismo de Acreditación"
        :activity="activity"
        :disabled="disabled"
      />
    </div>

    <!-- Certificación - Sistemas de Gestión -->
    <div v-if="['CSGAS', 'OCSG', 'CSA', 'CSIA'].includes(activity)">
      <branchs-critical-table
        title="3.2 LOCALIZACIONES CRÍTICAS DEL ORGANISMO SOLICITANTE (cuando aplique)"
        tableId="branchs-table"
        modalTitle="Añadir Locación critica del organismo solicitante"
        editModalTitle="Editar Locación critica del organismo solicitante"
        :activity="activity"
        :disabled="disabled"
      />

      <branchs-table
        title="3.3 LOCALIZACIONES NO CRÍTICAS DEL ORGANISMO SOLICITANTE (cuando aplique)"
        tableId="branchs-table"
        modalTitle="Añadir localización no critica"
        editModalTitle="Editar localización no critica"
        :activity="activity"
        :disabled="disabled"
        establishmentType="B"
      />

      <acc-virtual-sites-table
        title="3.4 SITIOS VIRTUALES DEL ORGANISMO SOLICITANTE (cuando aplique)"
        tableId="acc-virtual-sites-table"
        modalTitle="Añadir Sitio Virtual del Organismo"
        editModalTitle="Editar Sitio Virtual del Organismo"
        :activity="activity"
        :disabled="disabled"
      />

      <certification-activities-table
        title="3.5 INFORMACIÓN GENERAL DE LAS ACTIVIDADES DE CERTIFICACIÓN (ver requisito 3.1 de IAF MD12)"
        tableId="certification-activities-table"
        modalTitle="Añadir actividades de certificación"
        editModalTitle="Editar actividades de certificación"
        :activity="activity"
        :disabled="disabled"
      />

      <acc-bodies-table
        title="3.6 ACREDITACIONES OBTENIDAS CON OTROS ORGANISMOS DE ACREDITACIÓN"
        tableId="acc-bodies-table"
        modalTitle="Añadir Organismo de Acreditación"
        editModalTitle="Editar Organismo de Acreditación"
        :activity="activity"
        :disabled="disabled"
      />
    </div>

    <!-- Certificación - Personas -->
    <div v-if="['OCPE'].includes(activity)">
      <branchs-table
        title="3.2 OTRAS UBICACIONES FÍSICAS DEL ORGANISMO DE CERTIFICACIÓN SOLICITANTE"
        tableId="branchs-table"
        modalTitle="Añadir otras ubicaciones físicas"
        editModalTitle="Editar otras ubicaciones físicas"
        :activity="activity"
        :disabled="disabled"
        establishmentType="B"
      />

      <acc-virtual-sites-table
        title="3.3 SITIOS VIRTUALES DEL ORGANISMO SOLICITANTE (cuando aplique)"
        tableId="acc-virtual-sites-table"
        modalTitle="Añadir Sitio Virtual del Organismo"
        editModalTitle="Editar Sitio Virtual del Organismo"
        :activity="activity"
        :disabled="disabled"
      />

      <other-locations-table
        title="3.4 OTRAS UBICACIONES HABILITADAS PARA TOMA DE EXAMENES: Solo si no consta en los puntos anteriores"
        tableId="other-locations-table"
        modalTitle="Añadir otra ubicación"
        editModalTitle="Editar otra ubicación"
        :activity="activity"
        :disabled="disabled"
      />

      <certification-activities-table
        title="3.5 INFORMACIÓN GENERAL DE LAS ACTIVIDADES DE CERTIFICACIÓN (ver requisito 3.1 de IAF MD12)"
        tableId="certification-activities-table"
        modalTitle="Añadir actividades de certificación"
        editModalTitle="Editar actividades de certificación"
        :activity="activity"
        :disabled="disabled"
      />

      <acc-bodies-table
        title="3.6 ACREDITACIONES OBTENIDAS CON OTROS ORGANISMOS DE ACREDITACIÓN"
        tableId="acc-bodies-table"
        modalTitle="Añadir Organismo de Acreditación"
        editModalTitle="Editar Organismo de Acreditación"
        :activity="activity"
        :disabled="disabled"
      />
    </div>

    <!-- Certificación - Inspección -->
    <div v-if="['OINSP'].includes(activity)">
      <branchs-critical-table
        title="3.2 LOCACIONES CRITICAS DEL ORGANISMO SOLICITANTE (Cuando aplique)"
        tableId="branchs-table"
        modalTitle="Añadir Locación critica del organismo solicitante"
        editModalTitle="Editar Locación critica del organismo solicitante"
        :activity="activity"
        :disabled="disabled"
      />

      <branchs-table
        title="3.3 LOCACIONES NO CRITICAS, SUCURSALES O UNIDADES TÉCNICAS DEL ORGANISMO SOLICITANTE"
        tableId="branchs-table"
        modalTitle="Añadir Unidad Técnica / Local u Oficina no Critica"
        editModalTitle="Editar Unidad Técnica / Local u Oficina no Critica"
        :activity="activity"
        :disabled="disabled"
        establishmentType="B"
      />

      <acc-bodies-table
        title="4 ACREDITACIONES OBTENIDAS CON OTROS ORGANISMOS DE ACREDITACIÓN"
        tableId="acc-bodies-table"
        modalTitle="Añadir Organismo de Acreditación"
        editModalTitle="Editar Organismo de Acreditación"
        :activity="activity"
        :disabled="disabled"
      />
    </div>

    <!-- Laboratorio - Ensayos y Calibración -->
    <div v-if="['OENY', 'OEYC'].includes(activity)">
      <branchs-table
        title="4.2 UNIDADES TÉCNICAS (Cuando aplique)"
        tableId="branchs-table"
        modalTitle="Añadir unidad técnica"
        editModalTitle="Editar unidad técnicaa"
        :activity="activity"
        :disabled="disabled"
        establishmentType="TU"
      />

      <branchs-table
        title="4.3 LOCALES U OFICINAS NO CRITICAS (Cuando aplique)"
        tableId="branchs-table"
        modalTitle="Añadir local u oficina no critica"
        editModalTitle="Editar local u oficina no critica"
        :activity="activity"
        :disabled="disabled"
        establishmentType="B"
      />

      <acc-bodies-table
        title="4.4 ACREDITACIONES OBTENIDAS CON OTROS ORGANISMOS DE ACREDITACIÓN"
        tableId="acc-bodies-table"
        modalTitle="Añadir Organismo de Acreditación"
        editModalTitle="Editar Organismo de Acreditación"
        :activity="activity"
        :disabled="disabled"
      />
    </div>

    <!-- Laboratorio - Clínico -->
    <div v-if="['OCLN'].includes(activity)">
      <branchs-table
        title="4.2 UNIDADES TÉCNICAS (Cuando aplique)"
        tableId="branchs-table"
        modalTitle="Añadir unidad técnica"
        editModalTitle="Editar unidad técnicaa"
        :activity="activity"
        :disabled="disabled"
        establishmentType="TU"
      />

      <branchs-table
        title="4.3 LOCALES U OFICINAS NO CRITICAS (Cuando aplique)"
        tableId="branchs-table"
        modalTitle="Añadir local u oficina no critica"
        editModalTitle="Editar local u oficina no critica"
        :activity="activity"
        :disabled="disabled"
        establishmentType="B"
      />

      <acc-bodies-table
        title="4.4 ACREDITACIONES OBTENIDAS CON OTROS ORGANISMOS DE ACREDITACIÓN"
        tableId="acc-bodies-table"
        modalTitle="Añadir Organismo de Acreditación"
        editModalTitle="Editar Organismo de Acreditación"
        :activity="activity"
        :disabled="disabled"
      />
    </div>

    <!-- Laboratorio - Proveedores de Ensayos de Aptitud -->
    <div v-if="['OEAP'].includes(activity)">
      <acc-bodies-table
        title="3.1 ACREDITACIONES OBTENIDAS O EN PROCESO CON OTROS ORGANISMOS DE ACREDITACIÓN"
        tableId="acc-bodies-table"
        modalTitle="Añadir Organismo de Acreditación"
        editModalTitle="Editar Organismo de Acreditación"
        :activity="activity"
        :disabled="disabled"
      />
    </div>

    <!-- Laboratorio - Investigación y Control de Calidad -->
    <div v-if="['OICC'].includes(activity)">
      <branchs-table
        title="3.2. UNIDADES TÉCNICAS (Completar únicamente si dispone de laboratorios fuera de la matriz)"
        tableId="branchs-table"
        modalTitle="Añadir unidad técnica"
        editModalTitle="Editar unidad técnica"
        :activity="activity"
        :disabled="disabled"
        establishmentType="TU"
      />

      <acc-bodies-table
        title="3.3. ACREDITACIONES OBTENIDAS O EN PROCESO CON OTROS ORGANISMOS DE ACREDITACIÓN"
        tableId="acc-bodies-table"
        modalTitle="Añadir Organismo de Acreditación"
        editModalTitle="Editar Organismo de Acreditación"
        :activity="activity"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "#/Accreditation/Resources/assets/js/apiUrl";
export default {
  name: "Organization",
  mixins: [FormMixin],
  created() {
    this.data();
  },
  computed: {
    activity() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.accreditation_activity.code
        : null;
    },
    status() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.status.code
        : null;
    },
    disabled() {
      return !["100", "112"].includes(this.status);
    },
  },
  methods: {
    data() {
      this.$store.dispatch("getPoliticalDivision");

      if (this.$store.state.accreditation.org) {
        return;
      }

      this.axiosGet(
        `${actions.ORGANIZATIONS}/index?accAppId=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200) {
            this.$store.state.accreditation.org = { ...response.data };
          }
        })
        .catch((error) => {
          console.log("Organization: " + error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
